module.exports = __webpack_public_path__ + "static/media/locked.a5212e2e.svg";